export const AUTH_FIELD_USER_NAME = 'username';
export const AUTH_FIELD_PASSWORD = 'password';
